import { create } from "zustand";

const UseTarifsMainColor = create((set) => ({
  color: "#848686",
  setColor: (color) => set({ color: color }),
}));

export default UseTarifsMainColor;
